import { jqAccordion } from './modules/jqAccordion';
import { jqHeaderHeight } from './modules/jqHeaderHeight';
import { movileTelLink } from './modules/movileTelLink';
import { tabletViewport } from './modules/tabletViewport';
import { inview_setting } from './modules/inview_setting';
import { jqSmoothScroll } from './modules/jqSmoothScroll';
import { pageTop } from './modules/pageTop';
import { menu } from './modules/menu';


jqAccordion();
jqHeaderHeight();
movileTelLink();
tabletViewport();
inview_setting();
jqSmoothScroll();
pageTop();
menu();